<div>
  <div class="modal-window__header">
    <div class="modal-window__title">
      {{
        isEditMode
          ? (localizationConstants.CUSTOMER_SETTING_MODAL_EDIT_CUSTOMER | translate)
          : (localizationConstants.CUSTOMER_SETTING_MODAL_ADD_CUSTOMER | translate)
      }}
    </div>
    <div class="modal-window__label">
      {{ companyIdControl.value }}
    </div>
    <a (click)="closeDialogAsync(false)">
      <i class="c-icon c-icon--close-dark"></i>
    </a>
  </div>
  <form
    [formGroup]="form"
    id="modal-form"
    class="o-grid--medium u-mt--medium">
    <div
      *ngIf="!isEditMode"
      class="c-form-group o-grid__item col-12 col-sm-12">
      <label
        for="company"
        class="c-form-label"
        >{{ localizationConstants.CUSTOMER_SETTING_MODAL_SELECT_COMPANY | translate }}</label
      >
      <div class="company-search-input-wrapper">
        <input
          type="text"
          #companySelectInput
          name="company"
          id="company"
          [placeholder]="
            localizationConstants.CUSTOMER_SETTING_MODAL_COMPANY_ID
              | translate: { value: companyService.minLengthTerm }
          "
          matInput
          #trigger="matAutocompleteTrigger"
          (click)="openPanel(trigger)"
          [matAutocomplete]="auto"
          [value]="auto.isOpen ? '' : editCompanySettings?.companyName || ''"
          (input)="onCompanySelectInput($event)"
          class="c-select c-select--lg c-autocomplete__input"
          [class.is-invalid]="companyIdControl.invalid && companyIdControl.touched"
          [class.loading]="companyService.companiesLoading" />
        <app-loading-icon
          *ngIf="companyService.companiesLoading"
          class="u-color--light copmany-search-autocomplete__icon"></app-loading-icon>
      </div>
      <mat-autocomplete
        #auto="matAutocomplete"
        class="c-user-menu__autocomplete c-autocomplete c-autocomplete--lg"
        [displayWith]="companyAutocompleteDisplayFn"
        [autoActiveFirstOption]="false"
        [autoSelectActiveOption]="false"
        required
        (optionSelected)="onCompanySelectionChange($event?.option?.value)">
        <mat-option
          *ngFor="let company of companiesToAdd$ | async"
          [value]="company">
          {{
            company
              ? company.fullName + ", " + company.name
              : (localizationConstants.COMPANY_SELECT_MIN_LENGTH
                | translate: { value: companyService.minLengthTerm })
          }}
        </mat-option>
      </mat-autocomplete>
      <app-form-field-error [control]="companyIdControl"></app-form-field-error>
    </div>
    <div
      *ngIf="companyIdControl.value"
      class="o-grid__item u-w--full">
      <mat-accordion [multi]="true">
        <mat-expansion-panel
          [expanded]="true"
          class="mat-elevation-z0 u-border-1">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ localizationConstants.CUSTOMER_SETTINGS_SHIPPING | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="o-grid--medium u-mt--medium">
            <div class="c-form-group o-grid__item col-12 col-md-6">
              <label
                for="isShippingEnabledEdit"
                class="c-form-label"
                >{{ localizationConstants.CUSTOMER_SETTINGS_SHIPPING_ENABLED | translate }}</label
              >
              <div class="flex">
                <input
                  type="checkbox"
                  name="isShippingEnabledEdit"
                  id="isShippingEnabledEdit"
                  [formControl]="isShippingEnabledControl"
                  class="c-checkbox-slider--sm" />
                <label
                  for="isShippingEnabledEdit"
                  class="c-switch-slider--sm"></label>
              </div>
            </div>
            <div class="c-form-group o-grid__item col-12 col-md-6">
              <label
                class="c-form-label"
                for="unitOfMeasure"
                >{{ localizationConstants.CUSTOMER_SETTINGS_UNIT_OF_MEASURE | translate }}</label
              >
              <mat-select
                id="unitOfMeasure"
                name="unitOfMeasure"
                [formControl]="unitOfMeasureControl"
                [required]="isShippingEnabledControl.value"
                class="c-user-menu__select c-select c-select--lg">
                <mat-option
                  *ngFor="let unit of unitsOfMeasure"
                  [value]="unit.value">
                  {{ unit.title }}
                </mat-option>
              </mat-select>
              <app-form-field-error [control]="unitOfMeasureControl"></app-form-field-error>
            </div>
            <div class="c-form-group o-grid__item col-12 col-md-6">
              <label
                class="c-form-label"
                for="shippingAccount"
                >{{ localizationConstants.CUSTOMER_SETTINGS_SHIPPING_ACCOUNT | translate }}</label
              >
              <mat-select
                id="shippingAccount"
                name="shippingAccount"
                [formControl]="shippingAccountControl"
                [required]="isShippingEnabledControl.value"
                class="c-user-menu__select c-select c-select--lg">
                <mat-option
                  *ngFor="let account of data.availableShippingAccounts"
                  [value]="account.shippingAccountId">
                  {{ account.accountName }}
                </mat-option>
              </mat-select>
              <app-form-field-error [control]="shippingAccountControl"></app-form-field-error>
            </div>
            <div class="c-form-group o-grid__item col-12">
              <label
                class="c-form-label"
                for="shippingNotes"
                >{{ localizationConstants.CUSTOMER_SETTINGS_SHIPPING_NOTES | translate }}</label
              >
              <textarea
                id="shippingNotes"
                matInput
                type="text"
                name="shippingNotes"
                [formControl]="shippingNotesControl"
                class="c-textarea"
                [required]="isShippingEnabledControl.value">
              </textarea>
              <app-form-field-error [control]="shippingNotesControl"></app-form-field-error>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel
          [expanded]="true"
          class="mat-elevation-z0 u-border-1">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ localizationConstants.CUSTOMER_SETTINGS_TECH_COVER | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="o-grid--medium u-mt--medium">
            <div class="c-form-group o-grid__item col-12 col-md-6">
              <label
                for="isTechCoverEnabledEdit"
                class="c-form-label"
                >{{ localizationConstants.CUSTOMER_SETTINGS_TECH_COVER_ENABLED | translate }}</label
              >
              <div class="flex">
                <input
                  type="checkbox"
                  name="isTechCoverEnabledEdit"
                  id="isTechCoverEnabledEdit"
                  [formControl]="isTechCoverEnabledControl"
                  class="c-checkbox-slider--sm" />
                <label
                  for="isTechCoverEnabledEdit"
                  class="c-switch-slider--sm"></label>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="o-grid__item col-offset-6 col-3 u-mt--medium u-tablet">
      <button
        type="button"
        class="button--sm button-secondary button-block"
        (click)="closeDialogAsync(false)">
        {{ localizationConstants.BUTTON_CANCEL | translate }}
      </button>
    </div>
    <div class="o-grid__item col-12 col-md-3 u-mt--medium">
      <button
        type="button"
        (click)="closeDialogAsync(true)"
        class="button--sm button-primary button-block">
        {{ localizationConstants.BUTTON_SAVE | translate }}
      </button>
    </div>
  </form>
</div>
